import React from 'react'
import { Box, Typography } from '@mui/material'
import customColors from '../../styles/mui/szPaletteOverrides.json'
import custom from '../../styles/mui/szVariables.json'

export default function GaugeChart({ id, value, min, max, expectedLow, expectedHigh, label }: any) {
  let lowColor = customColors.palette.sz.colors.background
  let expectedColor = customColors.palette.sz.colors.background
  let highColor = customColors.palette.sz.colors.background
  let valueText = 'low'
  // Calculate angles for expected range
  const lowAngle = (((expectedLow - min) / (max - min)) * 180) - 90
  const highAngle = (((expectedHigh - min) / (max - min)) * 180) - 90
  if(value <= expectedLow) {
    lowColor = customColors.palette.primary.main
    valueText = 'low'
  }
  if(value > expectedLow && value <= expectedHigh) {
    expectedColor = customColors.palette.primary.main
    valueText = 'expected'
  }
  if(value > expectedHigh) {
    highColor = customColors.palette.primary.main
    valueText = 'high'
  }

  let angle = (((value - min)  / (max - min)) * 180)
  if(value<=min) {
    angle = -89
  }
  if(value<=expectedLow && value>=min) {
    const a = 90 - Math.abs(lowAngle)
    angle = -90 - (((value)/(expectedLow))*a*-1) 
    if(Math.abs(angle + 90) < 2 ) angle++
  }
  if(value>expectedLow && value<=expectedHigh) {
    angle = ((value/expectedHigh) * highAngle) 
    if(Math.abs(angle - highAngle) < 2 ) angle--
  }
  if(value>expectedHigh && value<max) {
    angle = ((value/max) * 180) - 90
  }
  if(value>=max) angle=90

  function alwaysTwoDecimal(number: number) {
    if(!number) return '0.00'
    return Intl.NumberFormat('en-EN',{ 
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
        useGrouping: false
    }).format(number);
  }

  const createArc = (
      startAngle: number, 
      endAngle: number, 
      color: string) => {
    const end = polarToCartesian(100, 100, 80, endAngle)
    const start = polarToCartesian(100, 100, 80, startAngle)
    const largeArcFlag = endAngle - startAngle <= 180 ? '0' : '1'
    return (
      <path
        d={`M ${end.x} ${end.y} A 80 80 0 ${largeArcFlag} 0 ${start.x} ${start.y}`}
        fill="none"
        stroke={color}
        strokeWidth="40"
      />
    )
  }

  const polarToCartesian = (
      centerX: number, 
      centerY: number, 
      radius: number, 
      angleInDegrees: number
    ) => {
    const angleInRadians = ((angleInDegrees - 90) * Math.PI) / 180.0
    return {
      x: centerX + radius * Math.cos(angleInRadians),
      y: centerY + radius * Math.sin(angleInRadians),
    }
  }

  const needlePoint = polarToCartesian(100, 100, 90, angle)

  

  return (
    <Box sx={{ 
          textAlign: 'center', 
          width: '250px',
          margin: 'auto', 
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignContent: "center",
          alignItems: 'center'
        }}>
     <Box width='210px'>      
        <Box sx={{ position: 'relative'}}>
          <Typography
            variant="szBody.Regular.xxSmall"
            sx={{
              position: 'absolute',
              left: '5px',
              bottom: '-45px',
              transform: 'rotate(-50deg)',
              transformOrigin: 'bottom left',
              backgroundColor: valueText==='low'?'#000':'inherit',
              color: valueText==='low'?'#FFF':'inherit',
              px: custom.spacing.xxxxs,
              pb: custom.spacing.xxxxs,
              borderRadius: '2px'
            }}>
            Low
          </Typography>
          <Box mb={custom.spacing.xxxs}>
            <Typography
              variant="szBody.Regular.xxSmall"
              sx = {{
                backgroundColor: valueText==='expected'?'#000':'inherit',
                color: valueText==='expected'?'#FFF':'inherit',
                px: custom.spacing.xxxxs,
                pb: custom.spacing.xxxxs,
                borderRadius: '2px'
              }}
              >
              Expected
            </Typography>
          </Box>
          <Typography
            variant="szBody.Regular.xxSmall"
            sx={{
              position: 'absolute',
              right: '5px',
              bottom: '-45px',
              transform: 'rotate(50deg)',
              transformOrigin: 'bottom right',
              backgroundColor: valueText==='high'?'#000':'inherit',
              color: valueText==='high'?'#FFF':'inherit',
              px: custom.spacing.xxxxs,
              pb: custom.spacing.xxxxs,
              borderRadius: '2px'
            }}>
            High
          </Typography>
        </Box>
        <svg viewBox="0 0 200 105" width="100%" height="100%">
          {createArc(-90, lowAngle-1, lowColor)}
          {createArc(lowAngle, highAngle, expectedColor)}
          {createArc(highAngle+1, 90, highColor)}
          <path d={`M 100 100 L 103 103 L 97 97 L ${needlePoint.x} ${needlePoint.y} L 103 103`} stroke="#2F2D26" strokeWidth="2" />
          <circle cx="100" cy="100" r="5" fill="#2F2D26" />
        </svg>
      </Box>
      <Typography variant="szBody.Regular.xSmall" 
        id={id}>
        {label}: {alwaysTwoDecimal(value)} kWh
      </Typography>
    </Box>
  )
}
